import  React from "react"
import { useRef } from "react"
import { useParams, useNavigate } from "react-router-dom"
import styles from "./style.module.scss"
import { FaRegCalendarAlt, FaCrown, FaFire } from "react-icons/fa"
import { LuTicket } from "react-icons/lu"
import { BsLightning } from "react-icons/bs"
import CountDown from "./CountDown"



const TabsBolao = ({ boloes, setSubBoloesSelect, activeKey, setActiveKey }) => {
  const navigate = useNavigate()
  const { id } = useParams()
  const containerRef = useRef(null)

  const isToday = (date) => {
    const today = new Date()
    const someDate = new Date(date)
    return someDate.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)
  }

  const formatarDate = (date) => {
    if (isToday(date)) {
      return "Hoje"
    } else {
      const d = new Date(date)
      return `${d.getDate().toString().padStart(2, "0")}/${(d.getMonth() + 1).toString().padStart(2, "0")}`
    }
  }

  const formatPrize = (value) => {
    let numberPart
    let wordPart

    if (value >= 1000000) {
      numberPart = (value / 1000000).toFixed(1)
      wordPart = Number.parseFloat(numberPart) > 1 ? "Mi" : "Mi"
    } else if (value >= 1000) {
      numberPart = (value / 1000).toFixed(1)
      numberPart = numberPart.endsWith(".0") ? numberPart.slice(0, -2) : Part
      wordPart = "K"
    } else {
      numberPart = value.toString()
      wordPart = ""
    }
    return { numberPart, word: wordPart }
  }

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(value)
  }

  const hexToRGBA = (hex, opacity) => {
    hex = hex.replace("#", "")
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((hexChar) => hexChar + hexChar)
        .join("")
    }
    const r = Number.parseInt(hex.substring(0, 2), 16)
    const g = Number.parseInt(hex.substring(2, 4), 16)
    const b = Number.parseInt(hex.substring(4, 6), 16)
    return `rgba(${r}, ${g}, ${b}, ${opacity})`
  }

  const handleTabChange = (key) => {
    navigate(`/bolao/${key}`, { replace: true })
    const selectedBolao = boloes.find((b) => b.id.toString() === key)
    if (selectedBolao) {
      setSubBoloesSelect(selectedBolao)
      setActiveKey(key)
    }
  }

  const sortedBoloes = [...boloes].sort((a, b) => b.especial - a.especial)

  return (
    <div className={styles.container} ref={containerRef}>
      {/* Compact Tabs Navigation */}
      <div className={styles.tabsNavigation}>
        {sortedBoloes.map((bolao) => {
          const isActive = activeKey === bolao.id.toString()
          const prizeData = formatPrize(bolao.premiacao)

          return (
            <div
              key={bolao.id}
              className={`${styles.tabItem} ${isActive ? styles.active : ""} ${bolao.especial === 1 ? styles.special : ""}`}
              onClick={() => handleTabChange(bolao.id.toString())}
              style={
                {
                  "--tab-color": bolao.cor,
                  "--tab-bg": hexToRGBA(bolao.cor, 0.08),
                  "--tab-border": hexToRGBA(bolao.cor, 0.2),
                } 
              }
            >
              {/* Compact Special Badge */}
              {bolao.especial === 1 && (
                <div className={styles.specialBadge}>
                  <FaCrown />
                </div>
              )}

              {/* Compact Prize Badge */}
              <div className={styles.prizeBadge} style={{ backgroundColor: bolao.cor }}>
                <span className={styles.prizeNumber}>R$ {prizeData.numberPart}</span>
                {prizeData.word && <span className={styles.prizeWord}>{prizeData.word}</span>}
              </div>

              {/* Compact Tab Header */}
              <div className={styles.tabHeader} style={{ backgroundColor: bolao.cor }}>
                <h3 className={styles.tabTitle}>{bolao.nome}</h3>
                <div className={styles.tabDate}>
                  <span>{formatarDate(bolao.data_sorteio)}</span>
                  {isToday(bolao.data_sorteio) && <BsLightning className={styles.todayIcon} />}
                </div>
              </div>

              {/* Active Indicator */}
              {isActive && <div className={styles.activeIndicator} style={{ backgroundColor: bolao.cor }}></div>}
            </div>
          )
        })}
      </div>

      {/* Compact Tab Content */}
      <div className={styles.tabContent}>
        {sortedBoloes.map((bolao) => {
          const isActive = activeKey === bolao.id.toString()
          if (!isActive) return null

          return (
            <div
              key={bolao.id}
              className={styles.tabPane}
              style={
                {
                  "--content-color": bolao.cor,
                  "--content-bg": hexToRGBA(bolao.cor, 0.03),
                  "--content-border": hexToRGBA(bolao.cor, 0.15),
                } 
              }
            >
              <div className={styles.contentGrid}>
                {/* Compact Prize Section */}
                {/* <div className={styles.prizeSection}>
                  <div className={styles.prizeDisplay}>
                    <span className={styles.prizeAmount} style={{ color: bolao.cor }}>
                      {formatCurrency(bolao.premiacao)}
                    </span>
                    {bolao.acumulou === 1 && (
                      <div className={styles.accumulatedBadge}>
                        <FaFire />
                        <span>Acumulado</span>
                      </div>
                    )}
                  </div>
                </div> */}

                {/* Compact Info Section */}
                <div className={styles.infoSection}>
                  <div className={styles.infoGrid}>
                    <div className={styles.infoItem}>
                      <LuTicket className={styles.infoIcon} style={{ color: bolao.cor }} />
                      <div className={styles.infoContent}>
                        <span className={styles.infoLabel}>Concurso</span>
                        <span className={styles.infoValue}>{bolao.concurso}</span>
                      </div>
                    </div>

                    <div className={styles.infoItem}>
                      <FaRegCalendarAlt className={styles.infoIcon} style={{ color: bolao.cor }} />
                      <div className={styles.infoContent}>
                        <span className={styles.infoLabel}>Sorteio</span>
                        <span className={styles.infoValue}>{formatarDate(bolao.data_sorteio)}</span>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Compact Countdown Section */}
                <div className={styles.countdownSection}>
                  <CountDown targetDate={bolao.data_sorteio} color={bolao.cor} />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default TabsBolao
